import * as Yup from 'yup';

const sliderSchema = Yup.object().shape({
  language: Yup.string().required('Language is required.'),
  imageUrl: Yup.string().required('Image Url is required.'),
  position: Yup.number()
    .min(0, "Please enter more than 0")
    .typeError("Must be Number"),
});

export default sliderSchema;